/** Canonical Virtual IP creation flow (STEP 1–7).
 *
 * VISTOERA_VIRTUAL_IP_7_STEP_FLOW_AND_UNIFIED_IMAGE_GENERATION_SELECTION_P1 —
 * Step5 = unified character generation + selection; former Step6 refinement
 * is an in-page capability, not a workflow step.
 */

export interface VirtualIpFlowStep {
  id: number
  order: number
  /** i18n key under virtualIp namespace — full step title shown next to "STEP N / 7". */
  labelKey: string
  /** i18n key — compact stepper label. */
  shortLabelKey: string
  /** Relative route under `virtual-ip-positioning/`. */
  route: string | null
  /** i18n key — completion requirement copy. */
  completionRequirementKey: string
}

export const VIRTUAL_IP_FLOW_STEPS: VirtualIpFlowStep[] = [
  {
    id: 1,
    order: 1,
    labelKey: 'flow.steps.1.label',
    shortLabelKey: 'flow.steps.1.shortLabel',
    route: 'step-1',
    completionRequirementKey: 'flow.steps.1.completionRequirement',
  },
  {
    id: 2,
    order: 2,
    labelKey: 'flow.steps.2.label',
    shortLabelKey: 'flow.steps.2.shortLabel',
    route: 'step-2',
    completionRequirementKey: 'flow.steps.2.completionRequirement',
  },
  {
    id: 3,
    order: 3,
    labelKey: 'flow.steps.3.label',
    shortLabelKey: 'flow.steps.3.shortLabel',
    route: 'step-3',
    completionRequirementKey: 'flow.steps.3.completionRequirement',
  },
  {
    id: 4,
    order: 4,
    labelKey: 'flow.steps.4.label',
    shortLabelKey: 'flow.steps.4.shortLabel',
    route: 'step-4',
    completionRequirementKey: 'flow.steps.4.completionRequirement',
  },
  {
    id: 5,
    order: 5,
    labelKey: 'flow.steps.5.label',
    shortLabelKey: 'flow.steps.5.shortLabel',
    route: 'step-5',
    completionRequirementKey: 'flow.steps.5.completionRequirement',
  },
  {
    id: 6,
    order: 6,
    labelKey: 'flow.steps.6.label',
    shortLabelKey: 'flow.steps.6.shortLabel',
    route: 'step-6',
    completionRequirementKey: 'flow.steps.6.completionRequirement',
  },
  {
    id: 7,
    order: 7,
    labelKey: 'flow.steps.7.label',
    shortLabelKey: 'flow.steps.7.shortLabel',
    route: 'step-7',
    completionRequirementKey: 'flow.steps.7.completionRequirement',
  },
]

export const VIRTUAL_IP_FLOW_TOTAL_STEPS = VIRTUAL_IP_FLOW_STEPS.length

/** 8-step era refinement page — legacy deep links only (not in stepper). */
export const VIRTUAL_IP_LEGACY_REFINEMENT_ROUTE = 'legacy/character-refinement'

export function virtualIpFlowStep(step: number): VirtualIpFlowStep | undefined {
  return VIRTUAL_IP_FLOW_STEPS.find((s) => s.id === step)
}
